import Vue from "vue";
import Vuex, { Store } from "vuex";
import axios from "axios";
import router from "@/router/index";
import swal from "sweetalert";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import login from "./login";
import loader from "./loader";
import account from "./account";
import devices from "./devices";
import cattle from "./cattle";
import virtualFence from "./virtual-fence";
import settings from "./settings";

Vue.use(Vuex);

const $api = "/api/";

var mainStore = new Vuex.Store({
  state: {
    token: null,
    refreshToken: null,
    $axios: axios.create({
      baseURL: $api,
    }),
    $axios_auth: axios.create({
      baseURL: $api,
    }),
    user: null,
    showLoader: false,
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
    login,
    loader,
    account,
    devices,
    cattle,
    virtualFence,
    settings,
  },
  strict: process.env.DEV,
  mutations: {
    SET_USER: function (state, user) {
      state.user = user;
    },
  },
});

mainStore.state.$axios_auth.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 602 && error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    } else {
      localStorage.removeItem("user");
      swal({
        position: "bottom-end",
        icon: "error",
        title: "Vaša sesija je istekla. Molimo Vas da se prijavite ponovo",
        showConfirmButton: false,
        timer: 5000,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      router.push("/login").catch(() => {});
    }
  }
);
export default mainStore;
